import React, { FC } from "react";
import { PerfumeResponse } from "../../../types/types";
import "./OrderItem.css";

type PropsType = {
  perfume: PerfumeResponse;
  quantity?: number;
};

const OrderItem: FC<PropsType> = ({ perfume, quantity }) => {
  const qty       = quantity ?? 1;
  const basePrice = perfume.actualPrice ?? perfume.price;
  const discount  = perfume.discount ?? 0;
  const unitPrice = basePrice - (basePrice * discount / 100);
  const lineTotal = unitPrice * qty;

  return (
    <div className="oi-row">
      <div className="oi-img-wrap">
        <img
          src={perfume.filename}
          alt={perfume.perfumeTitle}
          className="oi-img"
        />
      </div>

      <div className="oi-info">
        <span className="oi-title">{perfume.perfumeTitle}</span>
        <span className="oi-brand">{perfume.brand}</span>
        <div className="oi-meta-row">
          <span className="oi-qty">Qty: {qty}</span>
          {discount > 0 && (
            <span className="oi-discount-badge">{discount}% OFF</span>
          )}
        </div>
      </div>

      <div className="oi-price-col">
        <span className="oi-total">₹{lineTotal.toFixed(0)}</span>
        {discount > 0 && (
          <span className="oi-unit-old">₹{(basePrice * qty).toFixed(0)}</span>
        )}
      </div>
    </div>
  );
};

export default OrderItem;